export default __webpack_public_path__ + "static/eric-bitmoji-b2e7db1c87460d022681f6c1c788b6bc.png";